import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCalendar, FiPhone, FiCheck, FiArrowRight } = FiIcons;

const BookingCTA = () => {
  return (
    <section className="py-16 lg:py-24 bg-slate-900 relative overflow-hidden">
      {/* Background Gradients */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0">
        <div className="absolute top-0 left-1/4 w-64 h-64 lg:w-96 lg:h-96 bg-emerald-600/20 rounded-full blur-3xl mix-blend-screen"></div>
        <div className="absolute bottom-0 right-1/4 w-64 h-64 lg:w-96 lg:h-96 bg-teal-600/20 rounded-full blur-3xl mix-blend-screen"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <motion.h2 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl md:text-5xl font-bold text-white mb-4 lg:mb-6"
          >
            Start Your Recovery Today
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-lg lg:text-xl text-slate-300 mb-8 lg:mb-10 leading-relaxed max-w-2xl mx-auto"
          >
            Don't let pain hold you back any longer. Our expert team is ready to help you move better and feel stronger.
          </motion.p>

          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10 lg:mb-12 w-full sm:w-auto"
          >
            <a 
              href="#contact" 
              className="w-full sm:w-auto bg-emerald-500 text-white px-8 py-4 rounded-xl font-bold text-lg hover:bg-emerald-600 transition-colors shadow-lg shadow-emerald-500/25 flex items-center justify-center"
            >
              Book an Appointment <SafeIcon icon={FiArrowRight} className="ml-2 w-5 h-5" />
            </a>
            <a 
              href="tel:9510918372" 
              className="w-full sm:w-auto bg-white/10 backdrop-blur-sm text-white border border-white/20 px-8 py-4 rounded-xl font-bold text-lg hover:bg-white/20 transition-colors flex items-center justify-center"
            >
              <SafeIcon icon={FiPhone} className="mr-2 w-5 h-5" /> Call 95109 18372
            </a>
          </motion.div>

          {/* Features Grid - Vertical on Mobile */}
          <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-4 sm:gap-8 border-t border-white/10 pt-8 lg:pt-10">
            {[
              'No Referral Needed',
              'Direct Insurance Billing',
              'Evening & Weekend Hours'
            ].map((item, index) => (
              <div key={index} className="flex items-center justify-center text-slate-300 text-sm lg:text-base">
                <SafeIcon icon={FiCheck} className="w-5 h-5 text-emerald-400 mr-2" />
                <span>{item}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookingCTA;